import React from 'react';
import Button from '../../Button';
import { SearchIcon } from '../../Icon';
function SearchSubmitButton(_a) {
    var value = _a.value, onSubmit = _a.onSubmit, isSubmitEnabledAlways = _a.isSubmitEnabledAlways;
    return (React.createElement(Button, { className: "elmo-search__btn-submit", isText: true, icon: React.createElement(SearchIcon, { title: "Search" }), onClick: value || isSubmitEnabledAlways ? onSubmit : undefined, isDisabled: !value && !isSubmitEnabledAlways }));
}
export default SearchSubmitButton;
